module.exports = __webpack_public_path__ + "img/the-nickel-boys.60b1805d.png";